import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Advanced React Development',
                topics: [
                    'Component Composition & State Management: Modular UIs and Efficient Data Handling',
                    'Lifecycle & Rendering: Dive into React Methods and Faster App Techniques',
                    `Cross-Framework Integration: Multi-Stack Development in React`,
                ],
            },
            {
                title: 'Performance and Optimization',
                topics: [
                    'Code Splitting & SSR: Techniques for Web App Performance and Faster Loads',
                    'Caching & A11y: Enhancing User Experience and Building Inclusive Apps',
                ],
            },
            {
                title: 'Architecture and Scalability',
                topics: [
                    'Micro Frontends & Event-Driven Architecture: Modular UIs and Reactive Systems',
                    'Security & Containerization: Protecting Apps and Scaling with Containers',
                ],
            },
            {
                title: 'Testing, Deployment, and DevOps',
                topics: [
                    'Testing & CI/CD: Advanced React Testing and Deployment Best Practices',
                    'Docker & Monitoring: Containerization, Tools, and Serverless Architectures',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>&lt;What event is about&gt;</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;